const credits = document.querySelectorAll('.photo-credit-component')

if (credits) {
    credits.forEach(credit => {
        const overlay = credit.querySelector('.photo-credit__overlay')
        const trigger = credit.querySelector('.photo-credit__trigger')
        const details = credit.querySelector('.photo-credit__details')
        const closeCredit = credit.querySelector('.photo-credit__details button')

        const closeDetails = () => {
            details.classList.remove('photo-credit__details--visible')
            overlay.classList.remove('photo-credit__overlay--visible')
        }

        // Open Photo Credit Details
        trigger.addEventListener('click', () => {
            details.classList.add('photo-credit__details--visible')
            overlay.classList.add('photo-credit__overlay--visible')
        })

        // Close Photo Credit Details
        closeCredit.addEventListener('click', closeDetails)
        overlay.addEventListener('click', closeDetails)
    })
}
